import React from 'react';

import {
  Button,
  Group,
  Stack,
  Text,
  Radio,
  useMantineTheme,
  Card,
  Overlay,
  Title,
  Progress,
} from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { IconBarbell, IconChevronLeft } from '@tabler/icons-react';

import { CreateDemoGymFormValues } from './types';

const CreateDemoGymPrefilledDataForm = ({
  form,
  handleBackward,
  handleSubmit,
  isLoading = false,
}: {
  form: UseFormReturnType<CreateDemoGymFormValues>;
  handleBackward: () => void;
  handleSubmit: () => void;
  isLoading?: boolean;
}): JSX.Element => {
  const theme = useMantineTheme();

  return (
    <Stack>
      <Radio.Group label='Select Demo Account Type' size='md' {...form.getInputProps('demoType')}>
        <Group mt='xs'>
          <Card shadow='sm' radius='lg' p='xl' withBorder>
            <Radio
              value='blank'
              description={
                <Text size='md'>New gym owner experience - empty account to explore from scratch</Text>
              }
              label={<Text fw={600}>Blank Demo</Text>}
            />
          </Card>
          <Card shadow='sm' radius='lg' p='xl' withBorder>
            <Overlay color='#fff' opacity={0.9}>
              <Stack align='center' justify='center' h='100%' spacing={0}>
                <Text color='gray.7' size='lg' fw={600}>
                  Pre-filled data
                </Text>
                <Title color='gray.7' order={2} fw={600}>
                  Coming soon!
                </Title>
                <Group w='100%' position='center' spacing='xl' mt='md'>
                  <Progress radius='xl' h={12} color='gray' value={66} w='40%' />
                  <Text fw={600}>66%</Text>
                </Group>
              </Stack>
            </Overlay>

            <Radio
              value='pre-filled'
              disabled
              description={
                <Text size='md'>
                  Established Gym owners - account with samples members, classes and data
                </Text>
              }
              label={
                <Text>
                  <Text span fw={600}>
                    Pre-filled with sample data
                  </Text>{' '}
                  (Recommended)
                </Text>
              }
            />

            {form.values.demoType === 'pre-filled' && (
              <Stack mt='md' spacing='xs'>
                <Text fw={500}>Choose a template:</Text>
                <Card withBorder p='xs'>
                  <Group align='center'>
                    <IconBarbell size={32} color={theme.colors.gray[6]} />
                    <div>
                      <Text fw={600}>Sample Pre-filled Gym</Text>
                      <Text>Best for “Crossfit”</Text>
                    </div>
                  </Group>
                </Card>
              </Stack>
            )}
          </Card>
        </Group>
      </Radio.Group>

      <Group mt='md' grow>
        <Button
          size='md'
          leftIcon={<IconChevronLeft size={theme.fontSizes.lg} />}
          onClick={handleBackward}
          disabled={isLoading}
        >
          Back
        </Button>
        <Button size='md' onClick={handleSubmit} loading={isLoading} disabled={isLoading}>
          Create Demo Account
        </Button>
      </Group>
    </Stack>
  );
};

export default CreateDemoGymPrefilledDataForm;
